module.exports = __webpack_public_path__ + "img/azad-university.c412da8.svg";